import './Dial.scss';

import React from 'react';

// import { Gauge } from '@ant-design/charts';
import { Gauge } from '@ant-design/plots';

import { getConfig } from './config';

export interface DialProps {
  value: number | undefined;
  title: string;
  width?: number;
  height?: number;
  max?: number;
  invertColors?: boolean;
  fourDivisions?: boolean;
  invertValue?: boolean;
}

export const Dial: React.FC<DialProps> = ({
  value,
  title,
  width = 100,
  height = 100,
  // max = 10,
  // invertColors = false,
  // fourDivisions = false,
  invertValue = false
}) => {
  if (value === undefined) return null;

  const config = getConfig(
    width,
    height,
    invertValue ? 10 - value : value
    // max,
    // invertColors,
    // fourDivisions
  );

  return (
    <div className="crx-dial">
      <Gauge
        {...config}
        className="gauge"
        style={{
          minWidth: width + 'px'
        }}
      />
      <p className="crx-dial__title">{title}</p>
    </div>
  );
};
